module.exports = __webpack_public_path__ + "static/tile-8d448227ae22388c78506d1d0774d508.png";